export function initSearchStore(): void {
  const el = document.querySelector<HTMLElement>('.js-search-store');
  if (!el) {
    return;
  }
  const control = el.querySelector<HTMLInputElement>('.js-search-store-control');
  const storeElements = el.querySelectorAll<HTMLElement>('.js-search-store-item');

  if (control) {
    control.addEventListener('input', ({ target }) => {
      const value = (target as HTMLInputElement).value.toLowerCase().trim();
      for (const storeElement of storeElements) {
        storeElement.classList.add('hidden');
        const storeName = storeElement.textContent?.toLowerCase().trim() ?? '';
        if (storeName.includes(value)) {
          storeElement.classList.remove('hidden');
        }
      }
    });
  }
}
